import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import Layout from '@guest/shared/layouts/Layout.vue';
import { useInertiaRoutes } from 'inertiaRoutes';
import { i18nVue } from 'laravel-vue-i18n';
import AOS from 'aos';
import '@/../sass/themes/landkit/theme.scss';
import 'aos/dist/aos.css'; // You can also use <link> for styles
// import { Settings } from 'luxon';

AOS.init();

createInertiaApp({
    resolve: async (name) => {
        let page;
        try {
            //Search the guest section first
            page = (await import(`./vue/guest/pages/${name}.vue`)).default;
        } catch (ex) {
            try {
                //Search the auth section first
                page = (await import(`./vue/auth/pages/${name}.vue`)).default;
            } catch (e) {
                //Search the original pages location last
                page = (await import(`./Pages/${name}.vue`)).default;
            }
        }

        if (page.layout === undefined) page.layout = Layout;

        return page;
    },
    async setup({ el, App, props, plugin }) {
        /// For testing different timezones
        // Settings.defaultZone = 'America/New_York';
        // Settings.defaultZone = 'Europe/London';
        // Settings.defaultZone = 'America/Los_Angeles'; // Testing different timezones
        // Settings.defaultZone = 'Canada/Mountain'; // Testing different timezones

        const inertiaRoutesPlugin = useInertiaRoutes(props);

        createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(inertiaRoutesPlugin)
            .use(i18nVue, {
                fallbackLang: 'en',
                resolve: (lang) => {
                    return import(`../lang/${lang}.json`);
                }
            })
            .mount(el);
    },
    progress: {
        color: 'indigo'
    }
});

//Define ucwords to match PHP Functionality
String.prototype.ucwords = function () {
    let str = this.toLowerCase();
    return str.replace(/(^([a-zA-Z\p{M}]))|([ -][a-zA-Z\p{M}])/g, function (s) {
        return s.toUpperCase();
    });
};
